import { combineReducers } from 'redux';

import player from './player';
import config from './config';
import form from './form';
import search from './search';
import locations from './locations';
import shards from './shards';
import feedback from './feedback';
import timeseries from './timeseries';

export default combineReducers({
  player,
  config,
  form,
  locations,
  search,
  shards,
  feedback,
  timeseries
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js